import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { MagneticButton } from "./MagneticButton";

export const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section data-testid="cta-section" className="relative py-32 lg:py-48 overflow-hidden">
      <div
        aria-hidden="true"
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[min(95vw,1000px)] h-[560px] rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(109,0,255,0.32) 0%, rgba(139,44,255,0.12) 40%, transparent 70%)",
        }}
      />
      <div className="absolute inset-0 noise-overlay opacity-[0.04] pointer-events-none" aria-hidden="true" />

      <div className="relative max-w-5xl mx-auto px-6 text-center">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#C43CFF] mb-8">
            The Next Chapter Is Yours
          </p>
          <h2 className="font-display text-4xl sm:text-6xl lg:text-7xl font-extrabold uppercase tracking-tighter leading-[1.0]">
            Ready to make your <span className="text-gradient-purple">next move?</span>
          </h2>
          <p className="mt-8 text-base sm:text-lg text-[#A6A6B0] max-w-xl mx-auto leading-relaxed">
            Let's turn your next idea into something people remember.
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
            <MagneticButton
              data-testid="cta-primary"
              onClick={() => navigate("/contact")}
              className="group flex items-center gap-3 bg-[#6D00FF] hover:bg-[#8B2CFF] text-white text-sm font-semibold uppercase tracking-[0.12em] px-9 py-4 rounded-md transition-[background-color,box-shadow] duration-300 shadow-[0_0_40px_-8px_rgba(109,0,255,0.7)] hover:shadow-[0_0_56px_-8px_rgba(139,44,255,0.9)]"
            >
              Request a Proposal
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </MagneticButton>
            <button
              data-testid="cta-secondary"
              onClick={() => navigate("/contact")}
              className="text-sm font-semibold uppercase tracking-[0.12em] px-9 py-4 rounded-md border border-white/20 text-white/90 hover:border-[#8B2CFF]/60 hover:text-[#E8B6FF] transition-[border-color,color] duration-300"
            >
              Talk to Us
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
